var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 14.7866H13.3333M9.18141 2.92333L3.52949 7.31927C3.15168 7.61312 2.96278 7.76004 2.82669 7.94404C2.70614 8.10703 2.61633 8.29065 2.56169 8.48587C2.5 8.70626 2.5 8.94558 2.5 9.42421V15.4533C2.5 16.3867 2.5 16.8534 2.68166 17.21C2.84144 17.5236 3.09641 17.7785 3.41002 17.9383C3.76654 18.12 4.23325 18.12 5.16667 18.12H14.8333C15.7668 18.12 16.2335 18.12 16.59 17.9383C16.9036 17.7785 17.1586 17.5236 17.3183 17.21C17.5 16.8534 17.5 16.3867 17.5 15.4533V9.42421C17.5 8.94558 17.5 8.70626 17.4383 8.48587C17.3837 8.29065 17.2939 8.10703 17.1733 7.94404C17.0372 7.76004 16.8483 7.61312 16.4705 7.31927L10.8186 2.92333C10.5258 2.69562 10.3794 2.58176 10.2178 2.538C10.0752 2.49938 9.92484 2.49938 9.78221 2.538C9.62057 2.58176 9.47418 2.69562 9.18141 2.92333Z",
    stroke: "#6D7075",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b111e0726b00bd5d88f50e48e4722e6d.svg";
export { ForwardRef as ReactComponent };